import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { insightObjectResource } from '@atlassian/jira-router-resources-servicedesk-cmdb-object/src/services/index.tsx';
import { assetsObjectRoute } from '@atlassian/jira-router-routes-assets-routes/src/assetsObjectRoute.tsx';
import { getAssetsAppResources } from '@atlassian/jira-router-routes-servicedesk-cmdb-entries/src/common/getCmdbResources.tsx';
import { assetsObjectViewEntryPoint } from '@atlassian/jira-spa-apps-servicedesk-cmdb-object-v2/src/entrypoint.tsx';
import { createChromelessEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { LazyAssetsLayout, AssetsLayout } from '@atlassian/jira-assets-layout/src/ui/async.tsx';
import { AssetsPageConfigContainer } from '@atlassian/jira-assets-app-page-config-container/src/ui/async.tsx';
import Spinner from '@atlassian/jira-common-components-spinner/src/view.tsx';

const assetsObjectPageEntryPoint = createChromelessEntryPoint({
	main: assetsObjectViewEntryPoint,
});

export const assetsObjectRouteEntry = createEntry(assetsObjectRoute, () => ({
	group: 'assets',
	LayoutOverrideComponent: AssetsLayout,
	PageConfigContainerOverride: AssetsPageConfigContainer,
	skeleton: Spinner,
	entryPoint: () => assetsObjectPageEntryPoint,
	pageId: () => 'spa-apps/servicedesk/insight/cmdb-object-v2',
	resources: [...getAssetsAppResources(), insightObjectResource],
	forPaint: [LazyAssetsLayout],
	perfMetricKey: 'service-management.insight-cmdb.object-view-page-load',
	ufoName: 'assets-object-view-page',

	bifrost: {
		bifrostGroup: 'shell-only',

		bundling: {
			packageName: '@atlassian/jira-router-routes-assets-entries/src/assetsObjectRouteEntry.tsx',
			whichExportToUse: 'assetsObjectRouteEntry',
		},

		enabled: true,
	},
}));
